import React from 'react';
import { Route } from 'react-router-dom';
import { DefaultSuspense } from '../../components/crud/DefaultSuspense';

const ContactMessageIndex = React.lazy(() => import('./index'));
const ContactMessageDetail = React.lazy(() => import('./ContactMessageDetail'));


export const getContactMessageRoutes = () => {
    return (
        <Route path="contactMessage" element={<DefaultSuspense><ContactMessageIndex /></DefaultSuspense>} >
            <Route index element={<React.Fragment> </React.Fragment>} />
            <Route path=':contactMessageId' element={<DefaultSuspense><ContactMessageDetail /></DefaultSuspense>} />
        </Route>
    )
}